import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';

const faqData = [
  {
    question: '555电影网是什么网站？',
    answer: '555电影网是一个专注于高清电影免费在线观看的平台，提供海量电影资源，涵盖动作、喜剧、科幻、动画、悬疑、战争等多种类型，每日更新最新热门电影资源。',
  },
  {
    question: '555电影网的电影需要付费吗？',
    answer: '不需要！555电影网所有电影资源均免费提供在线观看，用户无需注册、无需付费即可畅享海量高清电影内容。',
  },
  {
    question: '电影播放会缓冲吗？',
    answer: '555电影网采用先进的视频加速技术，确保播放流畅不缓冲。同时我们提供多线路切换功能，用户可根据网络情况选择最优播放线路。',
  },
  {
    question: '电影资源多久更新一次？',
    answer: '555电影网每日更新电影资源，第一时间上架最新热门电影和院线大片，确保用户能够及时观看到最新的电影内容。',
  },
  {
    question: '如何使用555电影网？',
    answer: '您可以直接访问555dy.com，在首页浏览推荐电影，或通过分类导航查找感兴趣的电影类型，点击即可在线观看，无需下载任何软件。',
  },
];

export default function About() {
  useEffect(() => {
    document.title = '关于我们 - 555电影网 | 品牌介绍与联系方式';
    window.scrollTo(0, 0);
  }, []);

  const orgSchema = {
    name: '555电影网',
    url: 'https://555dy.com',
    description: '555电影网提供海量高清电影免费在线观看，最新热门电影、院线大片一网打尽。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@555dy.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchemaData = {
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  const webpageSchema = {
    name: '关于我们 - 555电影网',
    description: '了解555电影网的品牌故事、口碑评价和联系方式。555电影网致力于提供海量高清电影免费在线观看服务。',
    url: 'https://555dy.com/about',
  };

  const breadcrumbSchema = {
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://555dy.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  return (
    <>
      <SchemaOrg type="Organization" data={orgSchema} />
      <SchemaOrg type="FAQPage" data={faqSchemaData} />
      <SchemaOrg type="WebPage" data={webpageSchema} />
      <SchemaOrg type="BreadcrumbList" data={breadcrumbSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <Breadcrumb items={[{ name: '关于我们' }]} />

          {/* Hero */}
          <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20elegant%20cinema%20interior%20with%20empty%20red%20velvet%20seats%2C%20soft%20stage%20lighting%2C%20golden%20accents%2C%20atmospheric%20vintage%20theater%2C%20clean%20professional%20photography&width=1920&height=600&seq=about-hero-01&orientation=landscape"
              alt="555电影 - 关于我们"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
              <h1 className="text-2xl md:text-4xl font-bold font-heading text-background-50 mb-3">关于我们</h1>
              <p className="text-sm md:text-base text-background-200 max-w-lg">了解555电影网的品牌故事与核心价值</p>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-[900px] mx-auto">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">品牌介绍</h2>
              <div className="prose prose-base max-w-none text-foreground-700 leading-relaxed space-y-4">
                <p className="text-sm md:text-base">
                  555电影网成立于2020年，是国内领先的高清电影免费在线观看平台。我们致力于为广大电影爱好者提供最新、最全、最流畅的高清电影在线观影体验。经过多年的发展，555电影网已经积累了超过<strong>10,000部高清电影资源</strong>，覆盖动作、喜剧、科幻、动画、悬疑、战争、犯罪、奇幻、剧情等<strong>50多个电影分类</strong>。
                </p>
                <p className="text-sm md:text-base">
                  我们的团队由一群热爱电影的专业人士组成，包括资深电影编辑、技术工程师和内容运营专家。我们每天不间断地更新电影资源，确保用户能够在第一时间观看到<strong>最新热门电影和院线大片</strong>。
                </p>
                <p className="text-sm md:text-base">
                  555电影网始终坚持&ldquo;免费、高清、流畅&rdquo;的服务理念，采用业界领先的视频加速技术，为用户提供<strong>不缓冲、不卡顿的流畅观影体验</strong>。我们的使命是让每一位电影爱好者都能轻松享受到高品质的电影内容。
                </p>
              </div>
            </div>
          </section>

          {/* Reputation / Values */}
          <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-[900px] mx-auto">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">品牌口碑</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                {[
                  {
                    icon: 'ri-shield-check-line',
                    title: '安全可靠',
                    desc: '无需注册登录，无广告弹窗骚扰，保障您的观影隐私与安全。',
                  },
                  {
                    icon: 'ri-speed-up-line',
                    title: '流畅不缓冲',
                    desc: '采用多线路智能切换技术，确保高清视频播放流畅无卡顿。',
                  },
                  {
                    icon: 'ri-refresh-line',
                    title: '每日更新',
                    desc: '电影资源每日更新，第一时间为您带来最新热门电影内容。',
                  },
                ].map((item) => (
                  <div key={item.title} className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                      <i className={`${item.icon} text-xl text-accent-600`}></i>
                    </div>
                    <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-[900px] mx-auto">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">联系我们</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                    <i className="ri-mail-line text-lg text-secondary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900 mb-1">电子邮箱</h4>
                    <p className="text-sm text-foreground-600">contact@555dy.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                    <i className="ri-customer-service-2-line text-lg text-secondary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900 mb-1">在线客服</h4>
                    <p className="text-sm text-foreground-600">7×24小时在线，随时为您解答</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                    <i className="ri-question-answer-line text-lg text-secondary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900 mb-1">意见反馈</h4>
                    <p className="text-sm text-foreground-600">如您有任何建议或意见，欢迎随时联系我们</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                    <i className="ri-share-line text-lg text-secondary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900 mb-1">合作洽谈</h4>
                    <p className="text-sm text-foreground-600">欢迎内容合作、广告合作等商务洽谈</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-[900px] mx-auto">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">常见问题</h2>
              <div className="space-y-3">
                {faqData.map((item, index) => (
                  <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                    <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                      <h4 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{item.question}</h4>
                      <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 group-open:bg-primary-100 transition-colors">
                        <i className="ri-add-line text-sm text-secondary-600 group-open:hidden"></i>
                        <i className="ri-subtract-line text-sm text-primary-600 hidden group-open:block"></i>
                      </span>
                    </summary>
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="px-4 md:px-6 py-10 md:py-14 text-center">
            <div className="max-w-[600px] mx-auto">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-3">准备好开始观影了吗？</h2>
              <p className="text-sm text-foreground-600 mb-6">加入555电影网，畅享海量高清电影免费在线观看</p>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-semibold text-sm whitespace-nowrap transition-all duration-300 no-underline cursor-pointer"
              >
                立即观影 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}